import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { Image } from "@/components/ui/image";

/** Minimal venue-linked event note, shown only on La Vergüenza's profile. */
export default function KaraokeEventFeature({ listing }) {
  const { lang } = useLang();
  if (!/la verg[uü]enza/i.test(listing?.name || "")) return null;

  return (
    <section className="mt-5 border-y border-[#deded9] py-4 sm:py-5">
      <div className="flex items-center gap-4 sm:gap-5">
        {listing.cover_image && (
          <div className="h-[76px] w-[76px] sm:h-[92px] sm:w-[112px] shrink-0 overflow-hidden rounded-[4px] bg-[#e8e6e0]">
            <Image src={listing.cover_image} alt="" loading="lazy" quality={88} className="h-full w-full object-cover" />
          </div>
        )}
        <div className="min-w-0 flex-1">
          <p className="text-[9px] font-semibold uppercase tracking-[0.17em] text-[#ef3340]">
            {lang === "es" ? "En este lugar" : "At this venue"}
          </p>
          <h2 className="mt-1 text-[18px] sm:text-[21px] font-semibold leading-tight tracking-[-0.035em] text-[#171717]">
            {lang === "es" ? "Karaoke en La Vergüenza" : "Karaoke at La Vergüenza"}
          </h2>
          <p className="mt-1.5 max-w-[540px] text-[12px] sm:text-[13px] leading-relaxed text-[#696963]">
            {lang === "es" ? "Consulta con el lugar para conocer los próximos detalles." : "Check with the venue for the latest details."}
          </p>
        </div>
        <Link to="/events" className="shrink-0 inline-flex items-center gap-1.5 text-[9px] sm:text-[10px] font-bold uppercase tracking-[0.1em] text-[#171717] transition-colors hover:text-[#ef3340]">
          <span className="hidden sm:inline">{lang === "es" ? "Eventos" : "Events"}</span>
          <ArrowUpRight className="h-4 w-4" />
        </Link>
      </div>
    </section>
  );
}
